import { useStyles } from './styles';
import { Radio, Box } from '@mui/material';

function RadioButton(props) {
  const classes = useStyles();

  return (
    <Radio
      sx={classes.root}
      disableRipple
      color="primary"
      icon={<Box component="span" sx={classes.icon} />}
      checkedIcon={<Box component="span" sx={{ ...classes.icon, ...classes.checkedIcon }} />}
      {...props}
    />
  );
}

export default RadioButton;
